// frontend/src/api/banners.js
import { apiClient } from './index';

const bannersApi = {
  getActiveBanner: async () => {
    return await apiClient.get('/banners/active');
  },

  getAllBannersAdmin: async () => {
    return await apiClient.get('/banners/admin/all');
  },

  createBanner: async (data) => {
    return await apiClient.post('/banners/', data);
  },

  updateBanner: async (id, data) => {
    return await apiClient.put(`/banners/${id}`, data);
  },

  deleteBanner: async (id) => {
    return await apiClient.delete(`/banners/${id}`);
  }
};

export { bannersApi };